import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { Link } from "gatsby";
import Header from "../components/header";
import * as styles from "./games.module.scss";
import { graphql } from "gatsby";
import { movieDate } from "../utils/date";
import Modal from "../components/modal";
import { Fragment } from "react";

function calculateRatio(num_1, num_2) {
  let num;
  for (num = num_2; num > 1; num--) {
    if (num_1 % num == 0 && num_2 % num == 0) {
      num_1 = num_1 / num;
      num_2 = num_2 / num;
    }
  }

  return num_1 + ":" + num_2;
}

const Card = ({ data }) => {
  return data.map(value => (
    <div className={styles.artboard}>
      <div className={styles.card}>
        <div className={`${styles.card__side} ${styles["card__sideBack"]}`}>
          <div className={styles.card__cover}>
            <h4 className={styles.card__heading}>
              <span className={styles["card__headingSpan"]}>Stats</span>
            </h4>
          </div>
          <div className={styles.card__details}>
            <p>Namrata</p>
            <div>
              Number of Games won
              <p>
                {value.ngames}, {value.jgames}
              </p>
              <p>Ratio</p>
              <p>{calculateRatio(value.ngames, value.jgames)}</p>
            </div>
            <p>Jasmine</p>
          </div>
        </div>

        <div className={`${styles.card__side} ${styles["card__sideFront"]}`}>
          <div className={styles.card__theme}>
            <div className={styles["card__themeBox"]}>
              <p className={styles.card__subject}>{value.name}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
};

const Entries = ({ data }) => {
  const [showModal, setShowModal] = useState(-1);

  console.log(data);
  return (
    <div>
      <table>
        <tr>
          <th>Name</th>
          <th>Date</th>
          <th>Game</th>
          <th>Winner</th>
          <th>Proof</th>
        </tr>
        {data.map((value, index) => (
          <tr>
            <td>{value.node.frontmatter.name}</td>
            <td>{movieDate(value.node.frontmatter.date)}</td>
            <td>{value.node.frontmatter.game}</td>
            <td>{value.node.frontmatter.winner}</td>
            <td onClick={() => setShowModal(index)}>Click for proof</td>
          </tr>
        ))}
      </table>
      {showModal > -1 ? (
        <Modal height="50%" width="50%" toggleModal={() => setShowModal(-1)}>
          <img src={data[showModal].node.frontmatter.image} />
        </Modal>
      ) : null}
    </div>
  );
};

export default function Games({ data }) {
  const [tab, setTab] = useState("stats");

  const [items] = useState(() => {
    let items = [
      { name: "pubg", gameImage: "", ngames: 0, jgames: 0 },
      { name: "cod", gameImage: "", ngames: 0, jgames: 0 },
      { name: "odd-even", gameImage: "", ngames: 0, jgames: 0 },
    ];
    data.allMarkdownRemark.edges.forEach(value => {
      let item = items.find(item => item.name === value.node.frontmatter.game);
      if (value.node.frontmatter.winner === "Namrata") {
        item.ngames = item.ngames + 1;
      } else {
        item.jgames = item.jgames + 1;
      }
    });
    return items;
  });

  return (
    <div>
      <Link to="/">Home</Link>

      <Header headerText="Contact" />
      <button onClick={() => setTab("stats")}>Stats</button>
      <button onClick={() => setTab("entries")}>Entries</button>

      {tab === "stats" ? (
        <Card data={items} />
      ) : (
        <Entries data={data.allMarkdownRemark.edges} />
      )}
    </div>
  );
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "//games//" } }) {
      edges {
        node {
          frontmatter {
            name
            image
            date
            game
            winner
          }
        }
      }
    }
  }
`;
